export enum DetailsType {
  PLPHEADERCARD = 'PLPHEADERCARD',
  AllPRODUCTCARD = 'AllPRODUCTCARD',
  DETAILSSEARCHRESULTCARD = 'DETAILSSEARCHRESULTCARD',
  DETAILSABOCHECKBOXCARD = 'DETAILSABOCHECKBOXCARD',
  PDP_DETAILS = 'PDP_DETAILS',
  PLP_SEARCH_CARD = 'PLP_SEARCH_CARD',
  VARIANT_DRAWER_CARD = 'VARIANT_DRAWER_CARD',
  PDP_HEADER_CARD = 'PDP_HEADER_CARD',
  CART_CARD_VARIANT = 'CART_CARD_VARIANT',
  FREE_PRODUCT_CARD = 'FREE_PRODUCT_CARD',
  CHECKOUT_CARD = 'CHECKOUT_CARD',
  APOINT_REDEEM_PRODUCT_CARD = 'APOINT_REDEEM_PRODUCT_CARD',
  APOINT_REDEEM_PRODUCT_CARD_PRICE_DETAILS = 'APOINT_REDEEM_PRODUCT_CARD_PRICE_DETAILS',
  APOINT_REDEEM_CARD_PRICE_DETAILS = 'APOINT_REDEEM_CARD_PRICE_DETAILS',
  HORIZONTAL_CARD_DETAILS = 'HORIZONTAL_CARD_DETAILS',
}
